var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9997 0.00170278H0.99975C0.866336 -0.00631686 0.732739 0.0140548 0.607779 0.0614728C0.482819 0.108891 0.369339 0.182276 0.274831 0.276784C0.180323 0.371292 0.106938 0.484772 0.0595196 0.609732C0.0121017 0.734692 -0.00826998 0.868289 -0.000250347 1.0017V16.0017L2.99975 14.0017L4.99975 16.0017L6.99975 14.0017L8.99975 16.0017L10.9997 14.0017L13.9997 16.0017V1.0017C14.0078 0.868289 13.9874 0.734692 13.94 0.609732C13.8926 0.484772 13.8192 0.371292 13.7247 0.276784C13.6302 0.182276 13.5167 0.108891 13.3917 0.0614728C13.2668 0.0140548 13.1332 -0.00631686 12.9997 0.00170278ZM10.9997 10.0017H2.99975V8.0017H10.9997V10.0017ZM10.9997 6.0017H2.99975V4.0017H10.9997V6.0017Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.808468d6eff7a41dee814d27e327ccc8.svg";
export { ForwardRef as ReactComponent };